import React, { Component } from 'react';

//for connecting
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { CSVLink } from "react-csv";

import * as actionCreators from '../actions/report.js';

import { DropdownFilter } from './dropdownfilter.jsx';
import { Summaryreport } from './summaryreport.jsx';
import { Detailedreport } from './detailedreport.jsx';
import Rangecalendar from './rangeCalendar.jsx';
import Barchart from './barchart.jsx';
import Recordloading from './recordloading.jsx';

class DescriptionFilter extends Component {
  constructor(props){
    super(props);
    this.handleChange = this.handleChange.bind(this); 
    this.handleKeyPress = this.handleKeyPress.bind(this)    
  }

  handleChange(e) {
    this.props.setDescriptionFilter(e.target.value);
  }

  handleKeyPress(e){
    if(e.key === 'Enter'){
      this.props.getReport();
    }
  }

  render() {
    return(
      <div className="input-filter-container" >
        <span className="glyphicon glyphicon-search" />
        <input type="text" onChange={this.handleChange} placeholder=" نام رکورد ... " onKeyPress={this.handleKeyPress} value={this.props.report.paginationConfig.query.query || ''} />
      </div>
    );
  }
}

class Reportpage extends Component {
  constructor(props, context) {
    super(props, context);
    
    this.state = {
      exportData: []
    }

    this.handleReportTypeSelect = this.handleReportTypeSelect.bind(this);
    this.handleReportGroupBy = this.handleReportGroupBy.bind(this);
    this.handleGetReportButton = this.handleGetReportButton.bind(this);
    this.handleExportButton = this.handleExportButton.bind(this);
  }

  componentWillMount() {
    if(!!this.props.app.work_space.id){
      this.props.initPaginationConfig();
      this.handleGetReportButton();
    }
  }
  
  componentWillReceiveProps(nextProps,nextState) {
    if( JSON.stringify(this.props.app.work_space) !== JSON.stringify(nextProps.app.work_space)){
      this.props.initPaginationConfig();      
      this.handleGetReportButton();
    }
  }

  handleReportTypeSelect(type_) { //type is char 0 or 1
    this.props.changeReportType(type_);
  }

  handleReportGroupBy(e) {
    // TODO : above tree diagram we have a group section      
  }

  handleGetReportButton() {
    let pConf = {...this.props.report.paginationConfig};
    pConf.meta.page=1;
    pConf.meta.per_page=100;
    this.props.getRecords(pConf);
  }

  handleExportButton(done = () => {}) {
    let pConf = {...this.props.report.paginationConfig};
    pConf.meta.page=1;
    pConf.meta.per_page=100;
    this.props.getExport(pConf, done)
  }

  render() {
    const barchartRow = (
      <div className="row barchart-row">
        <Barchart
          calculateFunc={this.props.calculateBarchartList}
          records={this.props.report.all_records}
          barchartList={this.props.report.barchartList}
          total_sum={this.props.report.total_sum}
        />
      </div>
    )
    let loadedDiv = '';
    if(this.props.report.reportType === '1')
      loadedDiv = <Detailedreport {...this.props} />;
    else
      loadedDiv = 
      <Summaryreport 
        records={this.props.report.all_records}
        groupBy={this.props.report.groupBy}
        ws_id={this.props.app.work_space.id}
        reqReport={this.props.reqReport}
        loadingState={this.props.report.loadingGroupedReport}
        setGroupBy={this.props.setGroupBy}
        sortFunc={this.props.sortSummary}
        suborder={this.props.report.paginationConfig.query.suborder_by}
        groupedReport={this.props.report.groupedReport}
        total_sum={this.props.report.total_sum}
      />;

    return (
      <div>
        <div className="report-headbar row">
            <h4 >
              گزارش ها
            </h4>
            <a onClick={this.handleReportTypeSelect.bind(null,'0')} className={(this.props.report.reportType==="0" ? 'activated-link' : '')}  >
              <span> خلاصه </span>
            </a>
            <a onClick={this.handleReportTypeSelect.bind(null,'1')} className={(this.props.report.reportType==="1" ? 'activated-link' : '')} >
              <span> جزیی </span>
            </a>
        </div>
        <div className="container-fluid reportpage-container">
            <div className="row report-title">
              <div className="col-sm-5" >
              {this.props.report.reportType === "1" ? (<h2> گزارش جزیی </h2>) : (<h2> گزارش خلاصه </h2>) }
              </div>
              {this.props.report.export_file.length > 0 ? (
                <a id="export-link" href={"'"+this.props.report.export_file+"'"} download="hengam-export.csv" >
                  download link
                </a>
              ) : null}
              <div className="col-sm-4 date-filter pull-left">
                  <Rangecalendar onDatesChange={this.props.setDate} />
              </div>
            </div>
            
            <div className="row report-filters filter-box" >
              <div className="col-sm-2 filter-item">
                <DropdownFilter filterTitle={{en:'project',fa:'پروژه',attr:'id',header:'پروژه ها'}} {...this.props} />                
              </div>
              <div className="col-sm-2 filter-item">
                <DropdownFilter filterTitle={{en:'user',fa:'شخص',attr:'phone_number',header:'همکاران'}} {...this.props} />              
              </div>
              <div className="col-lg-6 col-sm-5 filter-item long-item">
                <DescriptionFilter {...this.props} />              
              </div>
              <div className="col-lg-2 col-sm-3 filter-item get-report-container">
                <button className="get-report" onClick={this.handleGetReportButton} >اعمال</button>
              </div>
            </div>
            <div className="row clear-filters">
                <a className="pull-left" style={{marginRight:"30px"}} onClick={this.props.clearFilters} > پاک کردن فیلترها </a>

                {
                  this.props.report.export_file && this.props.report.export_file.length > 0 ? (
                    <a className="pull-left" style={{marginRight:"30px", color: "red"}} onClick={this.props.clearExportFile} > حذف فایل خروجی فعلی </a>
                  ) : (
                    <a className="pull-left" style={{marginRight:"30px"}} onClick={this.handleExportButton} > ایجاد فایل خروجی </a>
                  )
                }

                {this.props.report.export_file && this.props.report.export_file.length > 0 ? (
                  <CSVLink
                  data={this.props.report.export_file}
                  className="pull-left"
                  filename="hengam-export.csv"
                >
                  دریافت فایل خروجی
                </CSVLink>
                ) :  null }

                
            </div>  
            { this.props.app.loading > 0 ? ( <Recordloading /> ) : ( barchartRow ) }
            { this.props.app.loading > 0 ? ( null ) : ( loadedDiv ) }
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    report: state.report,
    app: state.app
  }
}

function mapDispachToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}
  
export default connect(mapStateToProps, mapDispachToProps)(Reportpage);